import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{staticClass:"text-start yellow lighten-1"},[_c(VCol,{staticClass:"black--text",staticStyle:{"border":"1px solid black","border-bottom":"0"},attrs:{"cols":"12"}},[_vm._v(" Last Error In Full ")]),_c(VCol,{staticClass:"black--text",staticStyle:{"border":"1px solid black"},attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.lastErrorInFull)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }